module.exports = __webpack_public_path__ + "static/media/gl.df7247c9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gl.svg
// module id = 2100
// module chunks = 0